import React from "react";
import { GoalLevels } from "./Constants";
import styled, { withTheme } from "styled-components";
import NutritionItem from "../NutritionItem/NutritionItem";
import { useTranslation } from "react-i18next";

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.label`
  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.theme?.nero};
  margin-bottom: 14px;
`;

const GoalIcon = styled.i`
  color: ${(props) => props.color || "#000000"};
  margin-right: 4px;
`;

const GoalLabel = styled.span`
  color: ${(props) => props.color || "#000000"};
  font-weight: bold;
`;

const DailyTargets = (props) => {
  const { goalTitle, goalsList, goalMessage, calories } = props;

  const { t } = useTranslation();

  const getGoalLevelMessage = (level, percentage) => {
    switch (level) {
      case GoalLevels.greater:
        return `${t("appText.greaterThan")} ${percentage}`;
      case GoalLevels.less:
        return `${t("appText.lessThan")} ${percentage}`;
      case GoalLevels.lessOrEqual:
        return `${t("appText.lessThanOrEqualTo")} ${percentage}`;
      case GoalLevels.greaterOrEqual:
        return `${t("appText.greaterThanOrEqualTo")} ${percentage}`;
      case GoalLevels.equal:
        return `${t("appText.equalTo")} ${percentage}`;
      default:
        return `${t("appText.equalTo")} ${percentage}`;
    }
  };

  const buildGoalLabel = (goalLabel, goalColor) => {
    return (
      <GoalLabel data-testid="goal-label" color={goalColor}>
        {goalLabel}
      </GoalLabel>
    );
  };

  const buildGoalMessage = (item) => {
    return `${getGoalLevelMessage(item.goalLevel, item.goalValue)} ${t(
      "appText.from"
    )}`;
  };

  const buildGoalIcon = (goalColor) => {
    return (
      <GoalIcon
        data-testid="goal-item"
        color={goalColor}
        className="fas fa-flag-checkered"
      ></GoalIcon>
    );
  };

  return (
    <ComponentWrapper className="goal-card-body" data-testid="daily-goals">
      <Title>{goalTitle}</Title>
      {calories && (
        <NutritionItem
          value={calories}
          backgroundColor={props.theme?.lightShadeMagenta}
          titleColor={props.theme?.darkPurple}
        />
      )}
      {goalsList.map(function (item, index) {
        return (
          <p key={index}>
            {buildGoalIcon(item.goalColor)}
            {buildGoalMessage(item)}{" "}
            {buildGoalLabel(item.goalLabel, item.goalColor)}
          </p>
        );
      })}
      <p>
        {buildGoalIcon()}
        {goalMessage}
      </p>
    </ComponentWrapper>
  );
};
export default withTheme(DailyTargets);
